<template>
  <div id="q-app">
    <router-view />
    <div v-if="commitHash" class="b-hash-box">
      Commit:
      <a :href="`https://github.com/LoetjeGroepBV/atbl-frontend/commit/${commitHash}`" target="_blank">
        {{ commitHash }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'App',
  data () {
    const {
      root,
      channel,
      targetSid,
      lang,
      forceDate,
      extraFlow,
      oneTimeDealCode
    } = window.xprops || {}

    // DEV: Allow URL query params to override xprops for testing
    // Usage: http://localhost:8088?extraFlow=voucherDinerdeal#/
    let devExtraFlow = extraFlow
    if (process.env.DEV) {
      const urlParams = new URLSearchParams(window.location.search)
      devExtraFlow = urlParams.get('extraFlow') || extraFlow
    }

    let xprops = {
      root,
      channel,
      targetSid,
      lang,
      forceDate,
      extraFlow: devExtraFlow,
      oneTimeDealCode
    }

    return {
      commitHash: (process.env.DEV || process.env.DEV_FLAG) && process.env.COMMIT_HASH,
      xprops
    }
  },
  computed: {
    ...mapGetters(['token', 'currentToken', 'remember']),
    xpropsChangeIndicator () {
      let {
        root,
        channel,
        targetSid,
        extraFlow
      } = this.xprops
      return {
        root,
        channel,
        targetSid,
        extraFlow
      }
    }
  },
  watch: {
    currentToken: {
      handler (val, old) {
        this.fetchUserData()
      },
      immediate: true
    },
    'xprops.lang': {
      handler (val, old) {
        val && this.handleSetLanguage(val)
      },
      immediate: true
    },
    'xprops.forceDate': {
      handler (val, old) {
        if (val) {
          this.$nextTick(() => {
            this.setFormItem({ key: 'date', value: val })
            this.$router.push({ name: 'filter' }).catch(() => {})
          })
        }
      },
      immediate: true
    },
    'xprops.oneTimeDealCode': {
      handler (val, old) {
        this.setOneTimeDealCode(val || null)
      },
      immediate: true
    },
    xpropsChangeIndicator: {
      handler (val, old) {
        const data = JSON.parse(JSON.stringify(val))
        !isEmpty(data) && this.reinitWidgetConfig(val)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('app', ['setExtraFlow', 'setOneTimeDealCode']),
    ...mapActions('auth', ['fetchUserData', 'resetToken']),
    ...mapActions('directories', ['fetchRestaurants']),
    ...mapActions('availabilities', ['setTargetData']),
    ...mapActions('reservationForm', ['setFormItem']),
    updateProps (props) {
      Object.keys(this.xprops).forEach(propName => {
        if (!isEqual(this.xprops[propName], props[propName])) {
          this.xprops[propName] = props[propName]
        }
      })
    },
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
    },
    reinitWidgetConfig (data = {}) {
      let { root, channel, targetSid, extraFlow } = data
      this.$router.push({ name: 'index' }).catch(() => {})
      this.fetchRestaurants({ type: channel })

      this.setExtraFlow({ type: extraFlow || null })

      this.$nextTick(() => {
        if (root) {
          this.setTargetData(null)
        } else {
          this.setTargetData(targetSid)
        }
      })
    }
    // beforeWindowUnload (e) {
    //   console.log('beforeWindowUnload | REMEMBER_PROP: ', this.remember)
    //   if (!this.remember) {
    //     this.resetToken()
    //   }
    //   // Cancel the event
    //   e.preventDefault()
    //   // Chrome requires returnValue to be set
    //   e.returnValue = ''
    // }
  },
  created () {
    this.fetchRestaurants({ type: this.xprops.channel || 'DineTime' })
    window.xprops && window.xprops.onProps(props => { this.updateProps(props) })

    // window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy () {
    // window.removeEventListener('beforeunload', this.beforeWindowUnload)
  }
}
</script>
